import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { AnswerBubble, QuestionBubble } from ".";
import { ErrorFallback } from "../../..";
import { fixJson } from "../../../../core";

const HistoryQA = ({ QA }) => {
  let answer = QA.answer;
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <QuestionBubble message={QA} />
        {answer !== null && <AnswerBubble
          message={{ ...answer, question_date: QA.createdAt }}
          chat_agent={QA?.chat_agent ? QA.chat_agent : "BOT"}
        />}
      </ErrorBoundary>
    </>
  );
};

export { HistoryQA };
